import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'cpb-list-renderer-reset-filter',
  templateUrl: './list-renderer-reset-filter.component.html',
})
export class ListRendererResetFilterComponent {
  @Input() public form: FormGroup;
  @Input() public field: string;
  @Input() public resetFilterIcon: string;
  @Input() public defaultValue: string;
  @Output() public updateForm: EventEmitter<any> = new EventEmitter();

  public resetFilter(): void {
    const field = this.form?.get(this.field) || (this.form?.controls[this.field] as FormControl);

    if (field) {
      field.reset();
    }

    const value = this.defaultValue || field?.value;

    this.updateForm.emit({ [this.field]: value });
  }
}
